import { convertBlobToJpeg } from './image-blob-to-jpeg.utils';

export const getImageBlobFormData = async (fileUrl: string) => {
  const response = await fetch(fileUrl);
  const blob = await response.blob();
  const jpegBlob = await convertBlobToJpeg(blob);

  const formData = new FormData();
  formData.append('file', jpegBlob, 'image.jpg');

  return formData;
};
